export default __webpack_public_path__ + "static/media/service_last_active.1ded6c83.svg";